// extracted by mini-css-extract-plugin
export var badge = "badge-module--badge--16fad";